import PropTypes from 'prop-types';
import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { Box, IconButton, Typography } from '@mui/material';
import Iconify from '../Iconify';
import useResponsive from '../../hooks/useResponsive';

MyDialog.propTypes = {
  children: PropTypes.node,
  close: PropTypes.any,
  maxSize: PropTypes.string,
  open: PropTypes.bool,
  title: PropTypes.string,
};

export default function MyDialog({ open, close, title, maxSize = 'sm', children }) {
  const isDesktop = useResponsive('up', 'lg');

  return (
    <Dialog
      fullWidth={!isDesktop}
      maxWidth={maxSize}
      fullScreen={!isDesktop}
      open={open}
      onClose={close}
      sx={
        !isDesktop
          ? {
              '& .MuiDialog-paper': {
                margin: 0,
                width: '100%',
                maxWidth: '100%',
                height: '100%',
              },
            }
          : {
              '& .MuiDialog-paper': {
                borderRadius: '8px',
              },
            }
      }
      PaperProps={{
        sx: {
          m: isDesktop ? 2 : 0,
          width: '100%',
          height: isDesktop ? 'auto' : '100%',
          backgroundColor: '#fff',
          boxShadow: isDesktop ? '0 10px 40px rgba(0,0,0,0.15)' : 'none',
        },
      }}
    >
      <Box
        sx={{
          position: 'relative',
          textAlign: 'center',
          pt: 3,
          pb: 1,
        }}
      >
        <Typography
          sx={{
            fontSize: '20px',
            fontWeight: 500,
            color: '#333',
          }}
        >
          {title}
        </Typography>

        <IconButton
          onClick={close}
          sx={{
            position: 'absolute',
            top: 10,
            right: 10,
            color: '#aaa',
            '&:hover': {
              color: '#666',
              backgroundColor: 'transparent',
            },
          }}
        >
          <Iconify icon="mdi:close" width={22} />
        </IconButton>
      </Box>

      <DialogContent
        sx={{
          px: isDesktop ? 3 : 2,
          pb: isDesktop ? 4 : 3,
          maxHeight: isDesktop ? 'auto' : '90vh',
          overflowY: isDesktop ? 'visible' : 'auto',
        }}
      >
        {children}
      </DialogContent>
    </Dialog>
  );
}
